import React, { useCallback } from 'react';
import Switch from '@material-ui/core/Switch';

type SwitchButtonProps = Exclude<React.ComponentProps<typeof Switch>, 'checked' | 'onChange'> & {
    onChange?: (value: boolean) => void;
    value?: boolean | string;
};

const SwitchButton = ({ onChange, value, ...restProps }: SwitchButtonProps): React.ReactElement => {
    const handleOnChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => onChange && onChange(event.target.checked),
        [onChange]
    );

    return <Switch checked={value} onChange={handleOnChange} {...restProps} />;
};

SwitchButton.defaultProps = {
    onChange: undefined,
    value: undefined,
};

export default SwitchButton;
